import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import routes from "./routes/routes";
import ScrollToTop from "./functions/ScrollToTop";

function App() {
  const activeRoutes = routes.filter((route) => route.isActive)
 
  return (
    <>
      <Router>
        <Routes>
          {
            activeRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.component}>
                { route.children && (route.children.map(children => ( 
                  children.isActive && 
                  <React.Fragment key={children.title + '-' + children.index}>
                  {
                    route.variableChildren ?
                    <Route key={children.path} path=':pathname' element={children.component} ></Route>
                    :
                    <Route key={children.path} path={children.path} element={children.component}>
                      {
                        children.childrenCompontent && (
                          <>
                            <Route path=':pathname' element={children.childrenCompontent} ></Route>
                          </>
                        )
                      }
                    </Route>
                  }
                  </React.Fragment>
                )))
                }
              </Route>
            )
          )}
        </Routes>
        <ScrollToTop />
      </Router>
    </>
    
  );
}

export default App;